import { render, staticRenderFns } from "./UserDetailsModal.vue?vue&type=template&id=1a576a94&scoped=true&"
import script from "./UserDetailsModal.vue?vue&type=script&lang=js&"
export * from "./UserDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./UserDetailsModal.vue?vue&type=style&index=0&id=1a576a94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a576a94",
  null
  
)

export default component.exports